export default {
    required: (v) => !!v || "",
    phone: (v) => v?.length == 9 || "",
  };
  